/* eslint-disable jsx-a11y/label-has-associated-control */
import PropTypes from 'prop-types';
import React from 'react';
import FormikInput from 'src/components/formik/FormikInput';

function VehicleInsuranceForm() {
    return (
        <div className="vehicled">
            <div className="vehicled-body">
                <h5 className="vehicled-title">Insurance Details</h5>
                <div className="form-row">
                    <div className="form-group col-md-3">
                        <label>Min Tenure / Duration</label>
                        <FormikInput
                            name="meta.minTenure"
                            type="number"
                            className="form-control"
                        />
                    </div>
                    <div className="form-group col-md-3">
                        <label>Max Tenure / Duration</label>
                        <FormikInput
                            name="meta.maxTenure"
                            type="number"
                            className="form-control"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}

VehicleInsuranceForm.propTypes = {
    values: PropTypes.shape({
    }).isRequired,
};

export default VehicleInsuranceForm;
